var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as StaticPageFactory from "../../classes/definitions/brand/staticPage";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import StaticPagesList from '../../components/StaticPages/StaticPagesList/StaticPagesList';
import AppRoutes from '../../config/appRoutes';
import DashboardsReduxProps from "./StaticPagesReduxProps";
var StaticPages = /** @class */ (function (_super) {
    __extends(StaticPages, _super);
    function StaticPages() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.parentId = '-1';
        _this.state = {
            data: [],
            meta: null
        };
        _this.getAllStaticPages = function () {
            _this.api.getStaticPages(_this.parentId)
                .then(function (response) {
                var values = StaticPageFactory.createStaticPages(response.data);
                _this.setState({ data: values });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим статичната страница.', _this.props.history);
            });
        };
        _this.toNewStaticPage = function () {
            _this.props.history.push(AppRoutes.brand.path + '/' + _this.parentId + AppRoutes.staticPage.path);
        };
        _this.toEditStaticPage = function (selectedId) {
            if (selectedId !== '-1') {
                _this.props.history.push(AppRoutes.brand.path + '/' + _this.parentId + AppRoutes.staticPage.path + ("/" + selectedId));
            }
        };
        _this.toParentBrand = function () {
            _this.props.history.push(AppRoutes.brand.path + '/' + _this.parentId);
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return item.Id === id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        return _this;
    }
    StaticPages.prototype.componentDidMount = function () {
        this.parentId = _.get(this.props, 'match.params.brandId', '-1');
        if (this.parentId !== '-1') {
            this.getAllStaticPages();
        }
    };
    StaticPages.prototype.render = function () {
        var _this = this;
        var _a = this.state, data = _a.data, meta = _a.meta;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u0421\u0442\u0430\u0442\u0438\u0447\u043D\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewStaticPage, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432\u0430 \u0441\u0442\u0430\u0442\u0438\u0447\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430"),
                            React.createElement("a", { onClick: this.toParentBrand },
                                React.createElement("i", { className: "fa fa-backward" }),
                                " \u041D\u0430\u0437\u0430\u0434")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(StaticPagesList, { gridData: data, edit: this.toEditStaticPage, parentId: this.parentId, deleteItem: this.deleteItem, messages: this.messages }))))));
    };
    return StaticPages;
}(React.Component));
export default connect(null, DashboardsReduxProps.mapDispatchToProps)(StaticPages);



//////////////////
// WEBPACK FOOTER
// ./src/views/StaticPages/StaticPages.tsx
// module id = 543
// module chunks = 0